import React, { ReactNode } from 'react';
import { StyledDiv } from '../../../Theme/CommonStyled';
import AppHeader from './AppHeader';
import AppNavbar from './AppNavbar';
import useCreditsStore from '../../../Store/Credits';

type LayoutType = {
  title?: string;
  prevUrl?: string;
  children: ReactNode;
  goBack?: boolean;
};
const Layout: React.FC<LayoutType> = ({ children, ...rest }) => {
  return (
    <>
      <AppHeader {...rest} />
      <StyledDiv
        id="main-container"
        height={'calc(100vh - 155px)'}
        overflow={'auto'}>
        {children}
      </StyledDiv>
      <AppNavbar />
    </>
  );
};

export default Layout;
